import { push } from "connected-react-router";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  APPLICATION_MODE_NEW,
  APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE,
  LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION,
  LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION,
  ROUTE_PATH
} from "../../app/constants";
import { ERROR_STRING } from "../../app/errors";
import {
  applicationTypeFromLicenceSubType,
  isRenewalTypeApplication
} from "../../redux/slice/applicationsUtils";
import { ErrorMark } from "../../components/RegularComponents";
import { currentAgentApplicationSelector } from "../../redux/selector/collectorApplicationSelector";
import {
  setCurrentAgentLicenceSubType,
  setCurrentAgentPreviouslyLicencedStatus
} from "../../redux/slice/additionalApplicationsSlice";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import {
  LICENCED_EXEMPT,
  LICENCED_INDIVIDUAL,
  LICENCED_UNDER_BROKERAGE,
  NOT_LICENCED
} from "../../redux/slice/primaryAgencyApplicationSlice";
import styles from "./mra.module.scss";
import TopNavigationBar from "../TopNavigationBar";

export const PreviouslyLicencedMortgageBroker = (props) => {
  const { isModal = false, onEditSave = () => {} } = props;
  const dispatch = useDispatch();

  const agentApplication = useSelector(currentAgentApplicationSelector);
  const licencingSubType =
    agentApplication?.licencingSubType ?? LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION;
  const applicationType = applicationTypeFromLicenceSubType(licencingSubType);
  const applicationMode = APPLICATION_MODE_NEW;

  const [applicationSaveError, setApplicationSaveError] = useState(false);
  const [selectionError, setSelectionError] = useState(false);

  const previouslyLicencedStatus =
    agentApplication?.businessLicenceData?.previouslyLicencedStatus ?? null;
  const brokerLicenceNumber = agentApplication?.businessLicenceData?.brokerLicenceNumber;

  const isPrincipalBrokerApp = () =>
    applicationType === APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE;

  const handleNext = () => {
    setApplicationSaveError(false);

    if (previouslyLicencedStatus === null) {
      setSelectionError(true);
      return;
    }

    let appType = applicationType;

    if (!isPrincipalBrokerApp()) {
      // This is selected when the application is associate mortgage application.
      if (previouslyLicencedStatus === NOT_LICENCED) {
        if (isRenewalTypeApplication(agentApplication)) {
          appType = applicationTypeFromLicenceSubType(
            LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION
          );
          dispatch(
            setCurrentAgentLicenceSubType(
              LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION
            )
          );
        } else {
          appType = applicationTypeFromLicenceSubType(
            LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION
          );
          dispatch(
            setCurrentAgentLicenceSubType(
              LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION
            )
          );
        }
      } else {
        if (isRenewalTypeApplication(agentApplication)) {
          appType = applicationTypeFromLicenceSubType(
            LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION
          );
          dispatch(
            setCurrentAgentLicenceSubType(LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION)
          );
        } else {
          appType = applicationTypeFromLicenceSubType(
            LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION
          );
          dispatch(setCurrentAgentLicenceSubType(LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION));
        }
      }
    }

    dispatch(saveBusinessLicenceApplicationData(appType, applicationMode))
      .then((data) => {
        if (!isModal) {
          if (
            previouslyLicencedStatus === LICENCED_INDIVIDUAL ||
            previouslyLicencedStatus === LICENCED_UNDER_BROKERAGE
          ) {
            if (agentApplication?.businessLicenceData?.currentlyBrokerInNS && brokerLicenceNumber) {
              dispatch(push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_UPLOAD_CRIMINAL_RECORD_CHECK}`));
            } else {
              dispatch(push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_BROKER_LICENCE_IN_PROVINCES}`));
            }
          } else if (previouslyLicencedStatus === LICENCED_EXEMPT) {
            dispatch(push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_UPLOAD_WORK_HISTORY}`));
          } else if (previouslyLicencedStatus === NOT_LICENCED) {
            dispatch(push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_ASSOCIATE_HAS_LICENCE_IN_PROVICES}`));
            // dispatch(push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_ASSOCIATE_HAS_EDUCATION}`));
          }
        } else {
          onEditSave();
        }
        // const nextPath = hasWorkExperience ? ROUTE_PATH.MRA_IS_CANADA_RESIDENT : ROUTE_PATH.MRA_HAS_WORK_EXPERIENCE_NO
        // dispatch(push(`${ROUTE_PATH.MRA_APP}${nextPath}`))
      })
      .catch((err) => {
        setApplicationSaveError(true);
      });
  };

  const handleChange = (event) => {
    setSelectionError(false);
    const value = event.target.value;
    dispatch(setCurrentAgentPreviouslyLicencedStatus(value));
  };

  return (
    <div className={!isModal ? "container" : ""}>
      {/* Title */}
      {!isModal && (
        <>
          <TopNavigationBar
            {...props}
            applicationType={applicationType}
            applicationMode={applicationMode}
          />
          <div className="row">
            <div className="col-xs-12 col-lg-8">
              <h1>What type of licence are you applying for?</h1>
              <div className="topMarginMedium bottomMarginMedium">
                Select an option based on your history and type of licence you're applying for.
              </div>
            </div>
          </div>
        </>
      )}
      {/* Information Paragraphs */}
      <div className="row">
        <div className="col-lg-7">
          <fieldset className="ns-fieldset">
            <div className={"ns-radios ns-radios--small"}>
              {!isPrincipalBrokerApp() && (
                <div className="ns-radios__item">
                  <input
                    className="ns-radios__input"
                    type={"radio"}
                    value={NOT_LICENCED}
                    checked={previouslyLicencedStatus === NOT_LICENCED}
                    onChange={handleChange}
                    id={"mraApplication-not-licenced-type-input"}
                    name={"mraApplication-not-licenced-type-input"}
                  />
                  <label
                    id={"mraApplication-not-licenced-type-label"}
                    className="ns-radios__label"
                    style={{ display: "block" }}
                    htmlFor={"mraApplication-not-licenced-type-input"}
                  >
                    <div style={{ display: "block", margin: "0px 0px 5px 10px" }}>
                      Associate Mortgage Broker Licence
                    </div>
                  </label>
                </div>
              )}

              <div className="ns-radios__item">
                <input
                  className="ns-radios__input"
                  type={"radio"}
                  value={LICENCED_UNDER_BROKERAGE}
                  checked={previouslyLicencedStatus === LICENCED_UNDER_BROKERAGE}
                  onChange={handleChange}
                  id={"mraApplication-licenced-brokerage-type-input"}
                  name={"mraApplication-licenced-brokerage-type-input"}
                />
                <label
                  id={"mraApplication-licenced-brokerage-type-label"}
                  className="ns-radios__label"
                  style={{ display: "block" }}
                  htmlFor={"mraApplication-licenced-brokerage-type-input"}
                >
                  <div style={{ display: "block", margin: "0px 0px 5px 10px" }}>
                    Mortgage Broker Licence
                  </div>
                </label>
              </div>
              {!brokerLicenceNumber ? (
                <div className="ns-radios__item">
                  <input
                    className="ns-radios__input"
                    type={"radio"}
                    value={LICENCED_EXEMPT}
                    checked={previouslyLicencedStatus === LICENCED_EXEMPT}
                    onChange={handleChange}
                    id={"mraApplication-licenced-exempt-type-input"}
                    name={"mraApplication-licenced-exempt-type-input"}
                  />
                  <label
                    id={"mraApplication-licenced-exempt-type-label"}
                    className="ns-radios__label"
                    style={{ display: "block" }}
                    htmlFor={"mraApplication-licenced-exempt-type-input"}
                  >
                    <div style={{ display: "block", margin: "0px 0px 5px 10px" }}>
                      Mortgage Broker Licence
                    </div>
                    <span
                      style={{ display: "block", margin: "0px 0px 0px 10px" }}
                      className="bltReviewDecisionInfo"
                    >
                      You brokered mortgages for a federally regulated financial institution for at
                      least 24 of the 36 months immediately before the date of their application.
                    </span>
                  </label>
                </div>
              ) : null}
            </div>
          </fieldset>
        </div>
      </div>
      <div className="row">
        <div className={"col-lg-8" + (applicationSaveError || selectionError ? " has-error" : "")}>
          <button
            className={`${styles["question_button"]} btn-lg btn-default`}
            onClick={handleNext}
            name={"Yes"}
          >
            Save and next
          </button>
          {(applicationSaveError || selectionError) && ErrorMark()}
          {applicationSaveError && (
            <div className="ns-error-message help-block topMarginNormal">
              <span className="ns-visually-hidden">Error:</span>
              {ERROR_STRING.APPLICATION_SAVE_ERROR}
            </div>
          )}
          {selectionError && (
            <div className="ns-error-message help-block topMarginNormal">
              <span className="ns-visually-hidden">Error:</span>
              {ERROR_STRING.PREVIOUS_LICENCE_STATUS_NOT_SELECTED}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
